import client from './client';

/**
 * Notifications API functions
 * Handles user notifications and read status
 */
export const notificationsAPI = {
  /**
   * Get all notifications for a user
   * @param {string} userId - User ID
   * @returns {Promise<Array>} Array of notification objects
   */
  getNotifications: async (userId) => {
    const response = await client.get(`/notifications/${userId}`);
    return response.data;
  },
  
  /**
   * Mark notification as read
   * @param {string} notificationId - Notification ID
   */
  markAsRead: async (notificationId) => {
    await client.put(`/notifications/${notificationId}/read`);
  },
  
  /**
   * Mark all notifications as read for a user
   * @param {string} userId - User ID
   */
  markAllAsRead: async (userId) => {
    await client.put(`/notifications/${userId}/read-all`);
  },
  
  /**
   * Get unread notification count
   * @param {string} userId - User ID
   * @returns {Promise<number>} Unread notification count
   */
  getUnreadCount: async (userId) => {
    const response = await client.get(`/notifications/${userId}/unread-count`);
    return response.data.count;
  }
};
